import { LOCALE_CURRENCY } from '@/lib/constants/i18n';
import useCurrentLocale from './useCurrentLocale';

const useCurrentCurrency = () => LOCALE_CURRENCY[useCurrentLocale()];

export default useCurrentCurrency;
